import { Box, CircularProgress } from "@mui/material";

const TelehealthLoading = () => {
    return (
        <Box sx={{ display: "flex", justifyContent: "center", mt: "32px" }} data-test-id="loading_telehealth">
            <CircularProgress aria-label="Loading your Telehealth session" />
        </Box>
    );
};

export default TelehealthLoading;
